/* v8 ignore start */
import {JsonModel} from "@/lib/core/jsonModel";
import {LottieShapeKeyFrameBaseModel} from "@/lib/lottie/animatedProperties/lottieShapeKeyFrameModel";
import {TIntBoolean} from "@/lib/lottie/helpers/intBoolean";
import {LottieBezierModel} from "@/lib/lottie/helpers/lottieBezierModel";

export class LottieShapePropertyModel extends JsonModel<LottieShapePropertyModel.TJson> {
  public adjustTimingBy(factor: number): this {
    if (!this.json.a) return this;

    return this.update({k: this.json.k.map((keyframe) => ({...keyframe, t: keyframe.t * factor}))});
  }
}

export namespace LottieShapePropertyModel {
  export type TJson = IAnimatedShapeValueJson | IStaticShapeValueJson;

  export interface IBaseJson {
    /**
     * Property Index
     */
    ix?: number;

    /**
     * Whether the property is animated
     * @default 0
     */
    a?: TIntBoolean;

    /**
     * Expression
     */
    x?: string;
  }

  export interface IAnimatedShapeValueJson extends IBaseJson {
    a: 1;

    /**
     * Array of keyframes
     */
    k: LottieShapeKeyFrameBaseModel.IJson[];
  }

  export interface IStaticShapeValueJson {
    a?: 0;

    /**
     * Static Value
     */
    k: LottieBezierModel.IJson;
  }
}
/* v8 ignore stop */
